import FilterConstants from '../../filter-constants';
import * as ToleranceUtils from './tolerance-utils';
import * as CommonUtils from '../../utils/common';

let resistorToleranceIdeal = {
  name: FilterConstants.resistorTolerance.ideal,
  allowedMin: FilterConstants.Limits.RSMALL_COMP_LIMIT,
  allowedMax: FilterConstants.Limits.RBIG_COMP_LIMIT,
  multiplicationFactors: [1],
};

let resistorToleranceOneTenth = {
  name: FilterConstants.resistorTolerance.oneTenth,
  allowedMin: 10,
  allowedMax: 1000000,
  multiplicationFactors: [0.999, 1.0, 1.001],
};

let resistorToleranceFiveTenth = {
  name: FilterConstants.resistorTolerance.fiveTenths,
  allowedMin: 10,
  allowedMax: 1000000,
  multiplicationFactors: [0.995, 1.0, 1.005],
};

let resistorToleranceOne = {
  name: FilterConstants.resistorTolerance.one,
  allowedMin: FilterConstants.Limits.RSMALL_COMP_LIMIT,
  allowedMax: FilterConstants.Limits.RBIG_COMP_LIMIT,
  multiplicationFactors: [0.99, 1.0, 1.01],
};

let resistorToleranceFive = {
  name: FilterConstants.resistorTolerance.five,
  allowedMin: FilterConstants.Limits.RSMALL_COMP_LIMIT,
  allowedMax: FilterConstants.Limits.RBIG_COMP_LIMIT,
  multiplicationFactors: [0.95, 1.0, 1.05],
};

let resistorToleranceConfigs = [
  resistorToleranceIdeal,
  resistorToleranceOneTenth,
  resistorToleranceFiveTenth,
  resistorToleranceOne,
  resistorToleranceFive,
];

// let supportedESeries = [
//   FilterConstants.eSeries.E6,
//   FilterConstants.eSeries.E12,
//   FilterConstants.eSeries.E24,
//   FilterConstants.eSeries.E48,
//   FilterConstants.eSeries.E96,
//   FilterConstants.eSeries.ideal,
// ];

// export function computeNominalValue(idealValue, toleranceInput, forceRoundDirection) {
//   let selectedSeries = toleranceInput.resistorPreferredSeries;
//   let preferredSeries = getSeries(selectedSeries);
//   let nominalValue = ToleranceUtils.computeNominalValue(idealValue, preferredSeries, forceRoundDirection);

//   return nominalValue;
// }

export function getToleranceValues(value, selectedTolerance) {
  let toleranceConfig = ToleranceUtils.getToleranceConfig(resistorToleranceConfigs, value, selectedTolerance);
  if (
    CommonUtils.isNullOrUndefined(value) ||
    value === 0 ||
    CommonUtils.isNearInfinity(value) ||
    CommonUtils.isNullOrUndefined(toleranceConfig)
  ) {
    return {
      isToleranceCoerced: false,
      finalTolerance: FilterConstants.resistorTolerance.ideal,
      toleranceArray: [value],
    };
  }

  let isToleranceCoerced = toleranceConfig !== null;
  let finalTolerance = toleranceConfig.name;
  let toleranceArray = ToleranceUtils.getToleranceArray(value, toleranceConfig);
  return {
    isToleranceCoerced: isToleranceCoerced,
    finalTolerance: finalTolerance,
    toleranceArray: toleranceArray,
  };
}

// function getSeries(selectedSeries) {
//   var isSupported = supportedESeries.some((item) => item === selectedSeries);
//   if (!isSupported) throw `Series ${selectedSeries} is not supported. Supported series are ${supportedESeries}`;

//   return ToleranceUtils.getSeries(selectedSeries);
// }
